import { IconEscudo } from "./icons.js";

interface Props {
  /** El nombre del catálogo de salas. */
  name: string;
}

/**
 * El letrero de la sala, centrado arriba.
 *
 * Va en el centro y no pegado al carnet porque responde a otra pregunta: el carnet
 * dice quién eres y esto dice dónde estás. Separarlos deja que cada esquina tenga un
 * solo tema, que es lo que hace legible un HUD con cinco piezas.
 */
export function RoomSign({ name }: Props) {
  return (
    <div className="letrero">
      <span className="letrero__escudo">
        <IconEscudo />
      </span>
      <span className="letrero__nombre">{name}</span>
      <span className="letrero__sub">CAMPUS ESPOL</span>
    </div>
  );
}
